export const usePreviewUrl = (type: string, url: string): string => {
  return `${process.env.REACT_APP_NEXT_CLIENT_URL}/${type}/${url}`;
};
